import { Card, Flex, Statistic } from 'antd';
import { useGetTransitTime } from 'api/statistic/use-get-transit-time';
import { useGetTripsLoadByWarehouses } from 'api/statistic/use-get-trips-load-by-warehouses';
import { useFleetInsightsFiltersStore } from 'shared/stores/use-fleet-insights-filters';
import { WarehouseFormSelect } from 'components/common/warehouse-form-select';
import styles from './transit-time-stat.module.scss';
import type { ITransitTimeStatProps } from './types';

export const TransitTimeStat = (props: ITransitTimeStatProps) => {
  const { date, onChange } = props;
  const { filters } = useFleetInsightsFiltersStore();
  const { fromWarehouseId, toWarehouseId } = filters;

  const { data: transitData } = useGetTransitTime({
    filters: { date, fromWarehouseId, toWarehouseId },
  });

  const { data: tripsLoadData } = useGetTripsLoadByWarehouses({
    filters: { date, loadingWarehouseId: fromWarehouseId, unloadingWarehouseId: toWarehouseId },
  });

  return (
    <Flex gap={16} vertical>
      <Flex gap={16} wrap='wrap'>
        <WarehouseFormSelect
          name='fromWarehouseId'
          label='Loading warehouse'
          placeholder='Loading warehouse'
          handleChange={onChange}
          allowClear={false}
          withDeprecated={false}
          className={styles.warehouseSelect}
          internalOnly
        />
        <WarehouseFormSelect
          name='toWarehouseId'
          label='Unloading warehouse'
          placeholder='Unloading warehouse'
          handleChange={onChange}
          allowClear={false}
          withDeprecated={false}
          className={styles.warehouseSelect}
          internalOnly
        />
      </Flex>
      <Flex gap={16} wrap='wrap'>
        <Card className={styles.card}>
          <Statistic title='Avg. transit time' value={transitData?.avgDuration ?? 0} suffix='h' precision={1} />
        </Card>
        <Card className={styles.card}>
          <Statistic title='Average line load' value={tripsLoadData?.averageLoad ?? 0} suffix='%' precision={1} />
        </Card>
      </Flex>
    </Flex>
  );
};
